import { Injectable } from '@angular/core';
import { HttpClient,HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class WordpressService {

  constructor(private http: HttpClient) { }

  getPosts(feed): Observable<HttpResponse<any[]>> {
    return this.http.get<any>(feed.url, {
      params: {
        per_page: feed.per_page,
        page: feed.page,
        //search: feed.search,
      },
      observe: 'response',
    });
  }

  getCategories(url:string):Observable<HttpResponse<any[]>> {
    return this.http.get<any>(url,{
      params: { per_page: '100'},
      observe: 'response'
    })
  }

  getPost(slug:string): Observable<any[]> {
    return this.http.get<any[]>('http://backend.industriapaisaia.eus/wp-json/wp/v2/posts?_embed', {
      params: {
        slug: slug,
        per_page: '6',
      }
    });
  }

  getPage(slug:string): Observable<any[]> {
    return this.http.get<any[]>('http://backend.industriapaisaia.eus/wp-json/wp/v2/pages?_embed', {
      params: {
        slug: slug,
        per_page: '6',
      }
    });
  }


}
